<template>
  <b-form-checkbox-group
    v-model="local_value"
    :options="options"
    :name="name_checkboxes"
    stacked
  ></b-form-checkbox-group>
</template>

<script>
import {
  formControlMixin,
  props as formControlProps,
} from "bootstrap-vue/src/mixins/form-control";

import {
  formStateMixin,
  props as formStateProps,
} from "bootstrap-vue/src/mixins/form-state";

import { sortKeys } from "bootstrap-vue/src/utils/object";
import { makePropsConfigurable } from "bootstrap-vue/src/utils/props";

const props = makePropsConfigurable(
  sortKeys({
    ...formStateProps,
    ...formControlProps,
    value: null,
    options: {
      type: Array,
      default: [],
    },
  })
);

export default {
  mixins: [formControlMixin, formStateMixin],
  props,
  data: () => ({
    local_id: "",
    local_value: [],
  }),
  computed: {
    name_checkboxes() {
      return "checkboxes-" + this.local_id;
    },
  },
  watch: {
    local_value: function (value) {
      this.$emit("input", value);
    },
  },
  mounted() {
    this.local_id = this._uid;
  },
};
</script>
